export default "/images/vendor/flag-icons/flags/4x3/il.svg?1d83ed8b93b89da04c329be64a226a59";